import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
} from "@apollo/client";
import { onError } from "apollo-link-error";

let hasRefreshed = false;

const onErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, location, path }) => {
      alert(`Graphql error ${message}`);
    });
  }
  // if (networkError && networkError.statusCode === 401 && !hasRefreshed) {
  //   hasRefreshed = true;
  //   window.location.reload();
  // }
});
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found in localStorage");
    return {};
  }

  const formattedToken = `Bearer ${token.replace(/"/g, "")}`;
  console.log("Formatted Token: ", formattedToken); // Logging the token

  return {
    Authorization: formattedToken,
  };
};

// Middleware to add authorization headers
const authMiddleware = new ApolloLink((operation, forward) => {
  const headers = getAuthHeaders();
  if (headers.Authorization) {
    operation.setContext({
      headers: {
        ...headers,
      },
    });
  } else {
    console.warn("Authorization header is missing");
  }

  return forward(operation);
});

export const createUsersClient = () => {
  const userManagementHttpLink = new HttpLink({
    uri: "https://fsbe.mcb.co.ke/FinSightsGateway/usermanagement",
    //  uri: "https://localhost:7091/graphql/",
  });
  const userHttpLinkWithAuth = authMiddleware.concat(userManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(userHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createRoleClient = () => {
  const roleManagementHttpLink = new HttpLink({
    uri: "https://fsbe.mcb.co.ke/FinSightsGateway/rolemanagement",
  });
  const roleHttpLinkWithAuth = authMiddleware.concat(roleManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(roleHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createClientManagementClient = () => {
  const clientManagementHttpLink = new HttpLink({
    uri: "https://fsbe.mcb.co.ke/FinSightsGateway/clientmanagement",
  });
  const clientHttpLinkWithAuth = authMiddleware.concat(
    clientManagementHttpLink
  );

  return new ApolloClient({
    link: onErrorLink.concat(clientHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createSetupClient = () => {
  const setupManagementHttpLink = new HttpLink({
    uri: "https://fsbe.mcb.co.ke/FinSightsGateway/setupmanagement",
    //   uri: "https://localhost:7266/graphql/",
  });
  const setupHttpLinkWithAuth = authMiddleware.concat(setupManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(setupHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const loginUrl = {
  login: "https://fsbe.mcb.co.ke/FinSightsGateway/login",
  //login: "https://localhost:7173/userservice/login",
  // login:"https://localhost:7091/login/"
};

export const roleManagemenUrl = {
  // uri: "https://localhost:7092/graphql",
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/rolemanagement",
};

export const caseManagementUrl = {
  //uri: "https://localhost:7146/graphql/",
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/casemanagement",
};
export const documentManagementUrl = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/documentmanagement",
  baseFilePath:
    "https://fsbe.mcb.co.ke/FinSightsGateway/documentmanagement/ReadDocument?",
  // baseFilePath: "https://fsbe.mcb.co.ke/FinSightsGateway/documentmanagement/ReadDocumentNoSecurity?"
};

export const setupManagementUrl = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/setupmanagement",
  // uri: "https://localhost:7266/graphql/",
};

export const clientManagementUrl = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/clientmanagement",
};

export const userManagementUrl = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/usermanagement",
  //uri: "https://localhost:7091/graphql/",
};

export const AccountsandFinanceurl = {
  // uri: "https://localhost:7173/users/graphql",
  // uri: "https://localhost:7151/graphql/",
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/accountsmanagement",
};

export const documentUploadUrl = {
  // uri: "https://localhost:7294/documentmanager/UploadCaseDocument",
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/documentmanagement/UploadCaseDocument",
};

export const companyManagementUrl = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/companymanagement",
  upload_logo_uri:
    "https://fsbe.mcb.co.ke/FinSightsGateway/companymanagement/UploadLogo",
  // uri:"https://localhost:7157/graphql/",
};
export const smsservice = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/smsservice",
};
export const notificationservice = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/notificationservice",
};
export const ForgetPasswordApiService = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/forgotpassword",
};
export const deleteDocumentService = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/documentmanagement/DeleteCaseFile",
};
export const MCBSwitchService = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/mcbswitch",
  // uri: "https://localhost:7091/mcbswitch/",
};

export const emailService = {
  uri: "http://fsbe.mcb.co.ke/FinSightsGateway/emailservice",
};
export const statementUploader = {
  // uri: "https://finsights.mcb.co.ke/api/upload",
  uri: "https://fsbe.mcb.co.ke/finsightsgateway/api/upload",
  bank_url: "https://fsbe.mcb.co.ke/finsightsgateway/api/uploadBankStatement",
};
export const reportManagementUrl = {
  uri: "https://fsbe.mcb.co.ke/FinSightsGateway/reportmanagement",
  engine_uri: "https://finsights.mcb.co.ke/engine/generate-report",
  fs_engine_uri: "https://finsights.mcb.co.ke/engine/getStatementReport",
  fs2_engine_uri:
    "Https://fsbe.mcb.co.ke/finsightsgateway/api/generateFSReport",
  generate_report_uri:
    "Https://fsbe.mcb.co.ke/finsightsgateway/api/generateReport",

  // uri: "https://localhost:7265/graphql/",

  // engine_uri: "http://127.0.0.1:5050/generate-report",
  //   fs_engine_uri: "http://127.0.0.1:5050/engine/getStatementReport",
  //   fs2_engine_uri: "http://127.0.0.1:5050/engine/generateFSReport",
};
